import React, { useContext } from 'react';
import { Container, Row, Col, Spinner, Button, Card } from 'react-bootstrap';
import { AppContext } from '../App';

export const HomePage = () => {
	const { home, homeLoad, user, link, setPage, getCall, getTokens, getTokenServices, getTokenCustomers, getPayModes, setGetLoad,
		getCallReport, getCollectionReport, setPayWallet,
	} = useContext(AppContext);



	return (
		<>
			<style type="text/css">
				{`
                .metric-card {
                    border: none;
                    border-radius: 15px;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    transition: transform 0.2s;
                    color: white;
                }
                .metric-card:hover {
                    transform: translateY(-5px);
                }
                .metric-card .card-body {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .metric-card .icon {
                    font-size: 3rem;
                    opacity: 0.7;
                }
                `}
			</style>
			<Container fluid>
				{homeLoad ? (
					<div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
						<Spinner animation="border" variant="primary" />
					</div>
				) : (
					<>
						<div className="p-5 mb-4 bg-light rounded-3 text-center">
							<h1>Welcome back, {user?.profile?.first_name || 'User'}!</h1>
						</div>
						<Row className="mt-4 justify-content-center">
							<Col md={4} className="d-grid gap-2">
								<Button variant="primary" size="lg" onClick={() => {
									setPage('token');
									getTokens();
									getTokenServices();
									getTokenCustomers();
									getPayModes();
									getCall(setGetLoad, 'api/pw/get/wallet/billing/', setPayWallet);
								}}>
									Create New Token
								</Button>
							</Col>
							<Col md={4} className="d-grid gap-2">
								<Button variant="outline-secondary" size="lg" onClick={() => {
									getCollectionReport();
									setPage('collection_report');
								}}>
									View Detailed Reports
								</Button>
							</Col>
						</Row>
					</>
				)}
			</Container>
		</>
	);
};
